import { render, staticRenderFns } from "./SessionBackButton.vue?vue&type=template&id=46949288&scoped=true&"
import script from "./SessionBackButton.vue?vue&type=script&lang=js&"
export * from "./SessionBackButton.vue?vue&type=script&lang=js&"
import style0 from "./SessionBackButton.vue?vue&type=style&index=0&id=46949288&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46949288",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
